import { useEffect, useState } from 'react';

export default function ChatActivity({ steps = [], status }) {
  const [expanded, setExpanded] = useState(false);
  const pending = status === 'streaming';
  useEffect(() => { if (!pending) setExpanded(false); }, [pending]);
  if (!steps.length && !pending) return null;
  const latest = steps[steps.length - 1];
  const searches = steps.filter((step) => step.label?.startsWith('Searching documents')).length;
  const label = pending ? latest?.label || 'Connecting…' : status === 'complete' ? `Finished${searches ? ` · ${searches} ${searches === 1 ? 'search' : 'searches'}` : ''}` : 'Interrupted';
  return (
    <section className="mb-4 text-xs text-ink-muted" aria-label="Search activity">
      <button type="button" onClick={() => setExpanded(!expanded)} aria-expanded={expanded} aria-label={label} className="flex items-center gap-2 py-1">
        <span className={pending ? 'animate-pulse' : ''} aria-hidden="true">{pending ? '◌' : '✓'}</span>
        <span role="status">{label}</span><span aria-hidden="true">{expanded ? '⌃' : '⌄'}</span>
      </button>
      {expanded && <ol className="mt-3 ml-1 border-l border-edge pl-4 space-y-3">
        {steps.map((step) => <li key={step.id}>
          <p>{step.status === 'complete' ? '✓ ' : step.status === 'failed' ? '! ' : pending ? '◌ ' : '– '}{step.label}</p>
          {step.detail && <p className="mt-1 text-ink-subtle break-words">{step.detail}</p>}
        </li>)}
      </ol>}
    </section>
  );
}
